import { gql } from "@apollo/client";

export const GetMeetingSeriesDetails = gql`
  query GetMeetingSeriesDetails($id: String!) {
    meetingSeriesOne(id: $id) {
      id
      name
      description
      duration
      startAt
      endAt
      isSelfEnroll
      isWaitlistEnabled
      room {
        id
        name
      }
      isPrivateSession
      session {
        id
        name
      }
      privateSession {
        id
        duration
      }
      attendees {
        id
        client {
          user {
            firstName
            lastName
          }
        }
      }
      service {
        id
      }
      instructor {
        id
        user {
          firstName
          lastName
        }
      }
      location {
        id
        name
      }
      seriesInterval
      maxOccupancy
      waitlistMax
      scheduleFrom
      scheduleTo
      dows
      doms
    }
  }
`;

export const GetMeetingSeriesPage = gql`
  query GetMeetingSeriesPage(
    $pagination: PaginationInput!
    $locationId: String!
    $startAt: DateTime
    $endAt: DateTime
  ) {
    meetingSeriesPage(
      pagination: $pagination
      locationId: $locationId
      startAt: $startAt
      endAt: $endAt
    ) {
      items {
        id
        name
        description
        startAt
        endAt
        room {
          id
          name
        }
        service {
          id
        }
        instructor {
          id
          user {
            firstName
            lastName
          }
        }
        location {
          id
          name
        }
        scheduleFrom
        scheduleTo
        dows
        doms
      }
      totalRows
    }
  }
`;
